module.exports = __webpack_public_path__ + "img/serve_clients.ae8543cf.jpg";